import { useTranslation } from 'react-i18next'
import { useKeyDown } from '../../../../hooks/useKeyDown';
import { appTheme } from '../../../../helpers/utils/Utils';
import { useSelector } from 'react-redux';
import { withOidcSecure } from '@axa-fr/react-oidc';
import IlloPiggy from '../../../../assets/kudzu-plus-images/illo_piggy.png'


const CompletedDoneModalGoalRemove = ({ content1, btn1, btn1Function, btn2, btn2Function, icon }) => {
    const { t } = useTranslation();

    useKeyDown(() => {
        btn1Function();
    }, ["Enter"])
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const appThemeData = appTheme(kudzuPlusTrue);
    

    return (
        <div className='flex flex-col flex-start w-full'>
            <p className='font-hanken-grotesk lg:text-[19px] md:text-[19px] sm:text-[16px]  text-[14px] font-[400] sm:font-[500] leading-[24px] sm:leading-[22px] md:leading-[28px] text-[var(--modal-text-heading-clr)]'>{content1}</p>
           
             <img src={IlloPiggy} alt="complete" className='lg:w-[120px] md:w-[180px] sm:w-[92px] w-[180px] lg:my-16 md:my-14 sm:my-10 my-10 ' style={{marginLeft:"134px"}} />
         
            <div className='flex flex-col justify-center items-center w-full'>
                <div className='flex flex-col justify-center items-center gap-8 w-full'>
                    <button className="font-hanken-grotesk lg:text-[18px] md:text-[17px] sm:text-[15px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] bg-[#2965FB] text-white cursor-pointer border-2 px-2 py-4 border-[#2965FB] w-full" onClick={() => btn1Function()} onKeyDown={(e) => { if (e.key === "Enter") btn1Function() }}>{btn1}</button>
                    {btn2 &&
                        <button className="font-hanken-grotesk lg:text-[18px] md:text-[17px] sm:text-[15px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] text-[#ffffff] cursor-pointer border-2 px-2 py-4 border-[#2965FB] w-full" onClick={() => btn2Function()} onKeyDown={(e) => { if (e.key === "Enter") btn2Function() }}>{btn2}</button>
                    }
                </div>
            </div>
        </div>
    )
}

export default withOidcSecure(CompletedDoneModalGoalRemove);
